/* yy-frete.js - hidrata todo elemento [data-yy-frete]: cidade por IP (ipwho.is, depois geojs.io) ou CEP (ViaCEP),
   prazo por região (data-prazo) e entrega expressa. Usado pela página do produto e pelo carrinho lateral. */
(function () {
  if (window.__yyFrete) return;
  window.__yyFrete = true;

  var MESES = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  var MA = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
  var UF2REG = { AC:'norte',AP:'norte',AM:'norte',PA:'norte',RO:'norte',RR:'norte',TO:'norte',
    AL:'nordeste',BA:'nordeste',CE:'nordeste',MA:'nordeste',PB:'nordeste',PE:'nordeste',PI:'nordeste',RN:'nordeste',SE:'nordeste',
    DF:'centro',GO:'centro',MT:'centro',MS:'centro',
    ES:'sudeste',MG:'sudeste',RJ:'sudeste',SP:'sudeste',
    PR:'sul',SC:'sul',RS:'sul' };
  var NAME2UF = { 'acre':'AC','alagoas':'AL','amapa':'AP','amazonas':'AM','bahia':'BA','ceara':'CE','distrito federal':'DF',
    'espirito santo':'ES','goias':'GO','maranhao':'MA','mato grosso':'MT','mato grosso do sul':'MS','minas gerais':'MG',
    'para':'PA','paraiba':'PB','parana':'PR','pernambuco':'PE','piaui':'PI','rio de janeiro':'RJ','rio grande do norte':'RN',
    'rio grande do sul':'RS','rondonia':'RO','roraima':'RR','santa catarina':'SC','sao paulo':'SP','sergipe':'SE','tocantins':'TO' };
  var REGNAME2KEY = { 'norte':'norte','nordeste':'nordeste','centro-oeste':'centro','sudeste':'sudeste','sul':'sul' };

  function noAccent(s) { return (s || "").normalize("NFD").toLowerCase().replace(/[^a-z0-9 -]/g, "").trim(); }
  function toUF(uf, rn) { if (uf && uf.length === 2) return uf.toUpperCase(); return NAME2UF[noAccent(rn)] || ''; }
  function abd(days) { var d = new Date(), a = 0; while (a < days) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; }
  function fmt(d, ab) { return d.getDate() + ' de ' + (ab ? MA[d.getMonth()] : MESES[d.getMonth()]); }

  function hydrate(el) {
    if (!el || el.dataset.yyDone) return;
    el.dataset.yyDone = '1';
    var prazo = {}; try { prazo = JSON.parse(el.getAttribute('data-prazo')) || {}; } catch (e) {}
    var handling = parseInt(el.getAttribute('data-handling'), 10); if (isNaN(handling)) handling = 0;
    var dateEl = el.querySelector('[data-yy-date]');
    var locEl = el.querySelector('[data-yy-loc]');
    var iconEl = el.querySelector('[data-yy-icon]');
    var prefixEl = el.querySelector('[data-yy-prefix]');
    var PREFIX0 = prefixEl ? prefixEl.textContent : '';
    var ICON0 = iconEl ? iconEl.innerHTML : '';
    var EXCITY = noAccent(el.getAttribute('data-express-city') || '');
    var EXUF = (el.getAttribute('data-express-uf') || '').toUpperCase();
    var EXTEXT = el.getAttribute('data-express-text') || '';
    var BOLT = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 3 14 12 14 11 22 21 10 12 10Z"/></svg>';

    function setDate(rs) {
      var nums = (rs || '').match(/\d+/g) || [];
      if (!nums.length) { if (dateEl) dateEl.textContent = rs || '—'; return; }
      var mn = parseInt(nums[0], 10) + handling;
      var mx = parseInt(nums[1] != null ? nums[1] : nums[0], 10) + handling;
      var d1 = abd(mn), d2 = abd(mx), out;
      if (d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth()) out = fmt(d2, false);
      else if (d1.getMonth() === d2.getMonth()) out = d1.getDate() + ' e ' + fmt(d2, false);
      else out = fmt(d1, true) + ' e ' + fmt(d2, true);
      if (dateEl) dateEl.textContent = out;
    }
    function apply(city, uf, rn, regiao) {
      uf = toUF(uf, rn);
      if (EXCITY && EXTEXT && noAccent(city) === EXCITY && uf === EXUF) {
        if (prefixEl) prefixEl.textContent = EXTEXT;
        if (dateEl) dateEl.textContent = '';
        if (iconEl) iconEl.innerHTML = BOLT;
        el.classList.add('yy-frete--express');
      } else {
        if (prefixEl) prefixEl.textContent = PREFIX0;
        if (iconEl && ICON0) iconEl.innerHTML = ICON0;
        el.classList.remove('yy-frete--express');
        var key = 'padrao';
        if (uf && UF2REG[uf]) key = UF2REG[uf];
        else if (regiao && REGNAME2KEY[noAccent(regiao)]) key = REGNAME2KEY[noAccent(regiao)];
        setDate(prazo[key] || prazo.padrao);
      }
      if (city && locEl) locEl.textContent = city + (uf ? ', ' + uf : '');
      try { localStorage.setItem('yy_geo', JSON.stringify({ c: city, u: uf, r: regiao || '', t: Date.now() })); } catch (e) {}
    }

    setDate(prazo.padrao);
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem('yy_geo') || 'null'); } catch (e) {}
    if (cached && (Date.now() - cached.t) < 86400000 && (cached.u || cached.r)) {
      apply(cached.c, cached.u, '', cached.r);
    } else {
      var settled = false;
      fetch('https://ipwho.is/').then(function (r) { return r.json(); }).then(function (d) {
        if (settled || !d || d.success === false) return;
        if (d.country_code && d.country_code !== 'BR') return;
        settled = true; apply(d.city, d.region_code, d.region, '');
      }).catch(function () {});
      setTimeout(function () {
        if (settled) return;
        fetch('https://get.geojs.io/v1/ip/geo.json').then(function (r) { return r.json(); }).then(function (d) {
          if (settled || !d) return;
          if (d.country_code && d.country_code !== 'BR') return;
          settled = true; apply(d.city, '', d.region, '');
        }).catch(function () {});
      }, 1200);
    }

    var link = el.querySelector('[data-yy-ceplink]');
    var box = el.querySelector('.yy-frete__cepbox');
    var input = el.querySelector('[data-yy-cepin]');
    var btn = el.querySelector('[data-yy-cepbtn]');
    if (link) link.addEventListener('click', function () { box.hidden = !box.hidden; if (!box.hidden && input) input.focus(); });
    if (input) input.addEventListener('input', function () { this.value = this.value.replace(/\D/g, '').replace(/(\d{5})(\d)/, '$1-$2'); });
    function look() {
      var cep = (input.value || '').replace(/\D/g, '');
      if (cep.length !== 8) { input.focus(); return; }
      btn.disabled = true; btn.textContent = '…';
      fetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (r) { return r.json(); }).then(function (d) {
        btn.disabled = false; btn.textContent = 'OK';
        if (!d || d.erro) { input.focus(); return; }
        apply(d.localidade, d.uf, d.estado, d.regiao); box.hidden = true;
      }).catch(function () { btn.disabled = false; btn.textContent = 'OK'; });
    }
    if (btn) btn.addEventListener('click', look);
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); look(); } });
  }

  function scan() {
    var list = document.querySelectorAll('[data-yy-frete]:not([data-yy-done])');
    for (var i = 0; i < list.length; i++) hydrate(list[i]);
  }
  function init() {
    scan();
    var timer = null;
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        if (m[i].addedNodes.length) {
          if (!timer) timer = setTimeout(function () { timer = null; scan(); }, 50);
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
